module.exports = __webpack_public_path__ + "static/media/frothluxe-3.94e962a6.jpg";